const es = {
  9000001: "Trofeo de Navidad 2023",
  9000002: "Campeonato de Futuros SuperEx",
  9000003: "gane 30,000 USDT en premios del concurso",
  9000004: "Número de participantes",
  9000005: "Fondo de premios desbloqueado (USDT)",
  9000006: "Clasificación de Volumen de Negociación",
  9000007: "Clasificación de la Competencia de la Tasa de Beneficio",
  9000008: "Competición de Clasificación del Ránking de Ganancias ",
  9000009: `Competencia de clasificación de volumen de negociación: Desbloquee el premio más alto del fondo de bonos de <span style="color: #ffc72b;">20,000</span> USDT`,
  9000010: "Según el número de participantes, cuanto mayor sea el número de participantes, mayor será el premio, hasta 20 000 USDT",
  9000011: "Monto del fondo de premios",
  9000012: "Actualizaciones diarias a las 10:00 (UTC) durante el evento",
  9000013: "Estimación de recompensas",
  9000014: "Volumen total de comercio de futuros durante el período",
  9000015: "Reglas de recompensas",
  9000016: "Según el número de participantes, cuanto mayor sea el número de participantes, mayor será el premio, hasta 20 000 USDT",
  9000017: "Monto del fondo de premios (USDT)",
  9000018: "Clasificación de la tasa de beneficio del evento",
  9000019: "Inscripción",
  9000020: "Clasificación del monto de beneficio del evento",
  9000021: "Terminado",
  9000022: `Clasificación de la competencia de la tasa de ganancias - Disfruta de un bono de <span style="color: #ffc72b;">{moneyPond}</span> USDT `,
  9000023: `Ránking de Competición de Ganancias - Disfruta <span style="color: #ffc72b;">{moneyPond}</span> USDT en Bonus`,
  9000024: "Margen de beneficio acumulado de futuros",
  9000025: "Monto de beneficio acumulado de futuros",
  9000026: "No ha empezado",
  9000027: "Los 50 mejores participantes en la competencia de clasificación de beneficios serán recompensados. Para obtener más información, consulte las Reglas de Recompensa de Clasificación para obtener las recompensas.",
  9000028: "Los 50 mejores participantes en términos de rentabilidad serán recompensados, consulte las Reglas de Recompensa de la Clasificación de Operaciones para obtener la recompensa",
  9000029: "Clasificación del volumen de comercio del evento",
  9000030: "Registro exitoso",
  9000031: "Descargar la aplicación",
  9000032: "De vuelta a casa",

  //合约交易积分
  9100001: "Guardar Puntos",
  9100002: "Obtener Airdrop",
  9100003: "Canjear Recompensas",
  9100004: "Saldo de puntos",
  9100005: "Información interna",
  9100006: "Puntos de inicio de sesión",
  9100007: "Puntos de Trading",
  9100008: "Puntos de invitación",
  9100009: "Puntos de bonificación",
  9100010: "Sorteo de la suerte",
  9100011: "Consigue puntos",
  9100012: "Regla de puntos",
  9100013: "Detalles de los puntos",
  9100014: "Tienes que registrarte para participar en este evento. Haga clic para registrarse",
  9100015: "Has negociado durante {day} días consecutivos y has ganado {num} puntos",
  9100016: "Reglas de puntos",
  9100017: "Premio de puntos",
  9100018: "Cada sorteo de la suerte consume {point} puntos, y se puede sortear el máximo de {num} veces de sorteo por día.",
  9100019: "Número de sorteos de la suerte de hoy",
  9100020: "Usuario",
  9100021: "Puntos",
  9100022: "El saldo de puntos es insuficiente",
  9100023: "El saldo de puntos es insuficiente. Por favor, obtenga puntos antes de participar en el sorteo de la suerte.",
  9100024: "¡El número de sorteos de la suerte alcanzó su límite!",
  9100025: "El número de sorteos de la suerte de hoy alcanzó su límite. Inténtalo de nuevo mañana.",
  9100026: "Cómo ganar puntos",
  9100027: "Regístrese y participe en la actividad de negociación de contratos de puntos y gane puntos.",
  9100028: "Registro exitoso",
  9100029: "Te has registrado para participar en la actividad de comercio de futuros para ganar puntos. Ve y comercia para ganar más puntos (ya no disfrutarás de la comisión y las recompensas de devolución de dinero)",
  9100030: "Después de cancelar su registro, ya no recibirá puntos. ¿Estás seguro de que quieres cancelar tu registro?",
  9100031: "Centro de Actividades de Puntos de Trading",
  9100032: "Consigue puntos",
  9100033: "Tienes que registrarte para participar en este evento. Haga clic para registrarse",
  9100034: "Puedes ganar puntos operando con futuros de forma continua",
  9100035: "Los usuarios pueden ganar puntos por todas las operaciones de futuros",
  9100036: "Puntos de la tabla de clasificación",
  9100037: "Los cinco mejores usuarios de las clasificaciones de operaciones diarias recibirán puntos de bonificación adicionales",
  9100038: "Los usuarios invitados reciben puntos y el invitado puede recibir puntos de bonificación.",
  9100039: "{guy} ¡Ya ganó {num} puntos!",
  9100040: "¡Prueba el sorteo de la suerte ahora!",
  9100041: "Enhorabuena por obtener",
  9100042: "Todos los tipos",
  9100043: "Quédate en esta página",
  9100044: "Regístrese para participar",
  9100045: "Continuar operando",
  9100046: "Actualmente no hay actividades en curso. Por favor, siga prestando atención a las últimas noticias...",
  9100047: "Canjear tokens SCS",
  9100048: "",
  9100049: "",

  9100050: "Fechas",
  9100051: "Seleccionar fecha de inicio",
  9100052: "Seleccionar fecha de finalización",
  9100053: "A",
  9100054: "Tipo",

  9100055: "Puntos ganados = volumen de negociación * 1% (la dificultad se ajustará aún más a medida que aumente el volumen total de operaciones de la plataforma)",
  9100056: "Por ejemplo: el usuario utiliza una posición con un margen de 100 USDT*100X=10000 USDT",
  9100057: "Entonces solo necesitas un depósito de 100 USDT para obtener 100 puntos",
  9100058: "Los puntos de negociación son la única forma de obtener el token de la plataforma SCS",
  9100059: "Puntos de bonificación adicionales = puntos totales para el día * relación de recompensa de clasificación",
  9100060: "Clasificación",
  9100061: "Primer lugar",
  9100062: "Segundo lugar",
  9100063: "Tercer lugar",
  9100064: "Cuarto lugar",
  9100065: "Quinto lugar",
  9100066: "Los usuarios invitados reciben puntos y el invitado puede recibir puntos de bonificación.",
  9100067: "Factor de nivel",
  9100068: "Fórmula de cálculo: puntos de referencia obtenidos = puntos obtenidos por el invitado * coeficiente de nivel",
  9100069: "El coeficiente de nivel se ajustará de acuerdo con la situación real",
  9100070: "Por ejemplo: el usuario B participa en una actividad de puntos, y su invitado es el usuario A, y el número de invitaciones del usuario A ha alcanzado el nivel 3. El usuario B ha acumulado puntos = 360.000;",
  9100071: "Luego, los puntos de promoción acumulados que el usuario A puede obtener = 360000* 30% = 108,000",
  9100072: "Coeficiente de recompensa ",
  9100073: "1 usuario de comercio",
  9100074: "El volumen de comercio alcanza 5 million",
  9100075: "El volumen de comercio alcanza 20 million",

  9100076: "Transferencia ",

  //热币
  9100080: "Terminado",
  9100081: 'Haga clic en "Unirse ahora" para ganar recompensas',
  9100082: "Ver reglas",
  9100083: "Únete ahora",
  9100084: "Activo",
  9100088: "Comercio",
  9100089: "Depósito",
  9100090: "Ya te has registrado.",

  9100091: "Este evento ha terminado, ¡espera con ansias el próximo evento!",
  9100092: "El evento aún no ha comenzado, por favor manténgase atento.",
  9100093: "",
  9100094: "",

  //api key
  9100105: "Crear clave API",
  9100106: "Ver Documentación API",
  9100107: "Sistema de comercio integrado",
  9100108: "Crear/Gestionar clave API",
  9100109: "Desplegar API",
  9100110: "Comercio y solicitudes",
  9100111: "Plataforma líder de activos digitales",
  9100112: "Una amplia gama de servicios de comercio y gestión de activos digitales para satisfacer diversas necesidades comerciales.",
  9100113: "Proporcionando mejores servicios",
  9100114: "Tarifas de comercio más favorables, montos de comercio más altos, funciones de gestión de cuentas más flexibles, etc.",
  9100115: "La elección de millones de usuarios",
  9100116: "Asegurando un entorno comercial seguro, proporcionando soporte al cliente profesional, ayudándole a avanzar de manera constante en el mundo de los activos digitales.",
  9100117: "¿Cómo crear una clave API en SuperEx?",
  9100118: "¿Dónde puedo ver la documentación API de SuperEx?",
  9100119: "¿Qué hacer si encuentra problemas con el comercio en SuperEx?",
  9100120: "¿Cómo usar la API de SuperEx?",
  9100121: "Acceda a la API de SuperEx para un comercio más rápido y fluido",
  9100122: `Cuando haya iniciado sesión, coloque el cursor sobre el avatar - 'Gestión API' y haga clic en 'Crear clave API' para crear su clave API en SuperEx. Nota: Si no ha iniciado sesión, primero debe iniciar sesión en su cuenta de SuperEx.
También puede crear su clave API desde el enlace 'APIs' en la barra de navegación inferior.`,
  9100123: 'Puede hacer clic en <a style="color:#d1a53e;text-decoration:underline !important;font-size: 14px;font-family: Lato-Regular, Lato;font-weight: 400;" href="https://docs-api.superex.com/en/quickStart.html">Documentación API</a> para ver la documentación API de SuperEx.',
  9100124: 'Si encuentra algún problema o tiene sugerencias durante el uso, puede contactarnos de las siguientes maneras: <br>Contacte al servicio al cliente a través del "Centro de ayuda" en el sitio web oficial o enviando un correo electrónico a support@superex.com.',
  9100125: `Para usar la API de SuperEx, primero necesita:<br>
Registrarse e iniciar sesión en su cuenta de SuperEx.<br>
Crear una clave API, que generará un access_key y un secret_key para usted.<br>
Utilice este access_key y secret_key para firmar sus solicitudes.<br>
Dependiendo de sus necesidades, puede utilizar varias API proporcionadas por SuperEx, como la API de Datos de Mercado, la API de Comercio y la API de Cuentas. Asegúrese de que cada solicitud siga las instrucciones en la documentación API, con los encabezados HTTP y firmas adecuados.`,
  9100126: "Acción",
  9100127: "Crear nueva clave API",
  9100128: "Nombre de la clave API",
  9100129: "Ingrese el nombre de la clave API",
  9100130: "Permisos (Selección múltiple)",
  9100131: "Leer",
  9100132: "Comerciar",
  9100133: "Lista blanca de direcciones IP (opcional)",
  9100134: "Puede vincular hasta 10 direcciones IP a cada clave API, separadas por comas.",
  9100135: "He leído y estoy de acuerdo",
  9100136: "He leído y estoy de acuerdo con el Aviso de Riesgo del Usuario de API",
  9100137: "Crear",
  9100138: 'SuperEx le proporciona una API poderosa que le permite utilizar servicios como consulta de mercado y comercio automático. Vea cómo usarlo consultando la <a style="color:#0052D9;font-size: 14px;font-family: Lato-Regular, Lato;font-weight: 400;text-decoration:underline !important;color:#d1a53e;" href="https://docs-api.superex.com/en/quickStart.html">Documentación API</a>.',
  9100139: "Cada cuenta puede crear hasta 10 claves API.",
  9100140: `Las claves API que no están vinculadas a una IP expirarán automáticamente después de 90 días. Si tiene la intención de usarlas a largo plazo, puede renovar su clave API en 'Mi clave API' — 'Acción' — 'Renovar', extendiendo el período de validez por otros 90 días. Las claves API vinculadas a IP no tienen límite de expiración.`,
  9100141: "Mi clave API",
  9100142: "Permisos",
  9100143: "Dirección IP",
  9100144: "Renovar",
  9100145: "Crear una clave API requiere que deposite cualquier cantidad en su billetera al contado para activar su cuenta",
  9100146: "Confirmar la renovación de la clave API actual",
  9100147: "No divulgue su clave de acceso y clave secreta para evitar pérdidas de activos.",
  9100148: "Por razones de seguridad, se recomienda vincular claves API a direcciones IP específicas. Una clave API puede estar vinculada a un máximo de 20 direcciones IP o segmentos IP. Puede ingresar una dirección IP única o múltiples direcciones directamente, y separar diferentes direcciones con una coma. Por ejemplo: 192.168.1.1,192.168.1.2",
  9100149: "Después de una renovación exitosa, la fecha de caducidad será recalculada. Si utiliza la clave API a largo plazo, se recomienda vincular una dirección IP. Las claves API vinculadas no expiran y también son más seguras.",
  9100150: "¿Confirmar la eliminación de la clave API actual?",
  9100151: "Debe entender los siguientes riesgos:",
  9100152: "Su clave API está estrechamente relacionada con la seguridad de su cuenta. Cualquiera que conozca su clave API podría potencialmente controlar los activos de su cuenta. Por lo tanto, por favor protéjala adecuadamente, no divulgue su clave API a terceros y no la suba a sitios web o foros de terceros.",
  9100153: "Si su clave API se filtra por razones personales, incluidos, pero no limitados a, problemas de seguridad de activos y pérdidas económicas, usted asumirá toda la responsabilidad que surja de ello, y nosotros no asumiremos ninguna responsabilidad.",
  9100154: "Aviso de riesgo",
  9100155: "Soy consciente y estoy dispuesto a asumir el riesgo.",
  9100156: "Guardado",
  9100157: "Permisos",
  9100158: "La clave secreta solo se muestra una vez y no puede ser recuperada si se pierde, por favor guárdela de manera segura.",
  9100159: "No divulgue su clave de acceso y clave secreta para evitar pérdidas de activos.",
  9100160: "Si olvida su clave secreta, por favor elimine este par de claves y solicite uno nuevo.",
  9100161: "Ofrecemos API potentes para ayudarlo a integrar eficientemente las funciones de comercio en sus aplicaciones. Las API están categorizadas en Cuenta, Comercio y Datos de Mercado, lo que le permite configurar los permisos necesarios e implementar el comercio automatizado a través de la API.",
  9100162: "Tiempo de listado",
  9100163: "Crear nueva clave API",
  9100164: "Editar ",
  9100165: "Fecha de vencimiento",
  9100166: "Eliminar",
  9100167: "Creación exitosa",
  9100168: "Consejos",
  9100169: "Ok",
  9100170: "Aviso de riesgo del usuario de API",
  9100171: "Formato de dirección IP incorrecto",
  9100172: "",
  //自由区二维码分享页面
  91000951: "Spot Meme, un mundo criptográfico de los usuarios, por los usuarios, para los usuarios",
  91000961: "Abre la aplicación",
  //自由区二维码分享页面
  9100095: "SuperEx Free Market, un mundo criptográfico de los usuarios, por los usuarios, para los usuarios",
  9100096: "Abre la aplicación",
  9100097: "",
  9100098: "",

  //代理商
  101738: "¡Conviértete en un agente de SuperEx y disfruta de altas comisiones!",
  101739: "Invita a tus amigos a comerciar con SuperEx y o consigue el 50 % de la comisión. Comience a ganar comisiones después de sus contratos comerciales de referidos.",
  101740: "Conviértete en agente",
  101741: "¿Cómo obteno comisiones?",
  101742: "Aplicar para convertirse en agente",
  101743: "Si tiene comunidad, seguimiento de los medios de comunicación y otros recursos, puede solicitar convertirse en un agente, y después de una solicitud exitosa, puede actualizar a un agente.",
  101744: "Promover SuperEx",
  101745: "Comparte tu enlace de invitación con tu comunidad, seguidores o tus otros canales para una exposición promocional",
  101746: "Obtener comisión",
  101747: "Puedes ganar comisiones cuando los nuevos usuarios se registren e intercambien a través de tu enlace de invitación.",
  101748: "¿Cuánta comisión puedo ganar?",
  101749: "Cuando invitas a los usuarios a comerciar con SuperEx, obtienes el 20 % de la comisión de tu amigo como bono de invitación.",
  101750: "Si te conviertes en un agente de SuperEx, también recibirás un bono de agente del 50%.",
  101751: "¿Por qué convertirse en un corredor de SuperEx?",
  101752: "Comisiones altas",
  101753: "50% de reembolso de comisión",
  101754: "Soporte de tráfico de usuarios",
  101755: "Soporte de tráfico profesional, fácil acceso a los ingresos",
  101756: "Soporte de marca",
  101757: "Eventos globales fuera de línea con periféricos de regalo personalizados",
  101758: "Eventos globales fuera de línea",
  101759: "¡Reunión global de fans fuera de línea de SuperEx, las principales reuniones de la industria y soporte integral para cada agente, para ayudarles a mejorar sus ganancias!",
  101760: "Revisión fallida",
  101761: "Agentes",
  101762: "Gestión de canales",
  101763: "Crear canal",
  101764: "Canales afiliados",
  101765: "Método de promoción",
  101766: "Nombre del canal",
  101767: "Creado",
  101768: "Editar ",
  101769: "Ratio de reembolso de futuros",
  101770: "Relación de reembolso en spot",
  101771: "Gestión de la promoción",
  101772: "Código de invitación",
  101773: "Código de invitación",
  101774: "Número restante de enlaces promocionales por crear",
  101775: "Amigos",
  101776: "Código de invitación del agente",
  101777: "Número de referencias de los agentes",
  101778: "Códigos de invitación regulares",
  101779: "Número regular de referencias",
  101780: "Enlace de invitación",
  101781: "Canales regulares",
  101782: "Tablero de datos",
  101783: "Depósitos",
  101784: "Importe de la transacción",
  101785: "Comisión",
  101786: "Código de invitación",
  101787: "Relación de invitación móvil",
  101788: "Informes de contratos",
  101789: "Informes puntuales",
  101790: "Transacción",
  101791: "Centro de liquidación",
  101792: "Liquidación del contrato",
  101793: "Liquidación puntual",
  101794: "Comisión estimada",
  101795: "Registro de retiro",
  101796: "Ver activos",
  101797: "Cantidad retirada",
  101798: "Comisión acumulada",
  101799: "Los tokens actuales no cumplen con la cantidad de retiro. Puedes invitar a más usuarios a comerciar para obtener dinero de bonificación.",
  101800: "Descripción general de los datos del contrato",
  101801: "Descripción general de los datos puntuales",
  101802: "Detalles del contrato",
  101803: "Detalles puntuales",
  101804: "Todas las direcciones",
  101805: "Comisión estimada para el agente",
  101806: "Comisión estimada para el usuario",
  101807: "Tiempo de transacción",
  101808: "Para conocer las reglas detalladas, consulte el anuncio de SuperEx.",
  101809: "Formulario de solicitud del programa Agent",
  101810: "Tu idioma",
  101811: "¿En qué país estás? (Ejemplo: Irán)",
  101812: "¿Cuál es tu plataforma/canal principal?",
  101813: "¿Cuántos seguidores/fans/usuarios tienes en tu plataforma/redes sociales/sitio web?",
  101814: "Rellene el enlace de su plataforma/canal principal (introduzca la URL completa)",
  101815: "Otros canales sociales/enlaces de sitios web (introduzca la URL completa)",
  101816: "Tu nombre",
  101817: "Rellene los canales de redes sociales para ponerse en contacto con usted rápidamente (p. ej. ID de Telegram @xxx)",
  101818: "¿Dónde te enteraste del programa de agentes?",
  101819: "Amigo",
  101820: "Información adicional que puedes compartir con nosotros, como sobre ti mismo y una breve introducción a tu canal",
  101821: "¡Genial!",
  101822: "Ha completado con éxito la solicitud de agente SuperEx. Después de pasar la revisión, se lo notificaremos por correo electrónico.",
  101823: "El lapso de tiempo no puede exceder de 3 meses",
  101824: "Exitoso",
  101825: "Todos los retiros",
  101826: "Retirado",
  101827: "Los tokens actuales no cumplen con la cantidad de retiro. Puedes invitar a más usuarios a comerciar para obtener dinero de bonificación.",
  101828: "Gestión de usuarios",
  101829: "ID de usuario",
  101830: "Ratio de reembolso de futuros",
  101831: "Relación de reembolso al contado",
  101832: "Tiempo de inscripción",
  101833: "Detalles de la transacción",
  101834: "Comprar largo",
  101835: "Vender corto",
  101836: "Vender largo",
  101837: "Comprar corto",
  101838: "Tiempo de retiros",
  101839: "Moneda de retiro",
  101840: "Número de retiros",
  101841: "Comisión",
  101842: "Cantidad que se puede retirar",
  101843: "Retirar",
  101844: "Comunidad",
  101845: "Correo electrónico (este correo electrónico se utilizará para recibir información del agente, por favor revise su correo electrónico de spam si no se encuentra ningún mensaje de verificación)",
  101846: "Código de verificación",
  101847: "Tenga paciencia mientras revisamos su solicitud. Le notificaremos cuando se apruebe por correo electrónico.",
  101848: "Lo sentimos, su solicitud de agente no fue aprobada",
  101849: "Volver a aplicar",
  101850: "Descripción general de los datos",
  101851: "Tasa de comisión del contrato de los agentes",
  101852: "Tasa de comisión en Spot de los agentes",
  101853: "Ha sido descalificado como agente, si tiene alguna pregunta, póngase en contacto con el administrador",
  101854: "Todo el tiempo",
  101855: "Ayer",
  101856: "Este mes",
  101857: "El mes pasado",
  101858: "Número de comerciantes",
  101859: "Depósito total",
  101860: "Seleccione el código de invitación",
  101861: "Ganancias brutas",
  101862: "Comisión de Futuros",
  101863: "Comisión de Spot",
  101864: "En espera de",
  101865: "Retirado",
  101866: "Para ser desbloqueado",
  101867: "*Los ingresos de la comisión deben retirarse a My Spot Account para ser utilizados.",
  101868: "Confirmación de retiro",
  101869: "¿Estás seguro de que quieres retirar todos los tokens a mi cuenta Spot?",
  101870: "Los tokens actuales no cumplen con la cantidad de retiro. Puedes invitar a más usuarios a comerciar para obtener dinero de bonificación.",
  101871: "Desbloqueado",
  101872: "Invertido",
  101873: "Calificación de agente cancelada",
  101874: "Ya es un agente",
  101875: "Descripción general de los datos del canal",
  101876: "Datos del usuario",
  101877: "A la cuenta de Futuros de Cloud Wallet",
  101878: "A la cuenta Spot de Cloud Wallet",
  101879: "Detalles del comercio al contado",
  101880: "Detalles de la negociación de futuros",
  101881: "Centro de Liquidación de Futuros",
  101882: "Centro de liquidación de spot",
  101883: "Informe de eficacia",
  101884: "Seleccionar idioma",
  101885: "Introduce tu respuesta",
  101886: "Selecciona el nombre del canal",
  101887: "Retirada de la comisión",
  101888: "Introduzca el nombre del canal",
  101889: "Seleccione el método de promoción",
  101890: "Introduzca notas",
  101891: "Activos disponibles para su retirada",
  101892: "Confirmar retiro",
  101893: "Establecer la relación de reembolso de futuros del usuario",
  101894: "Establecer la relación de reembolso de spot del usuario",
  101895: "Informe de rendimiento de futuros",
  101896: "Informe de rendimiento de spot",
  101897: "Conversión (USDT)",
  101898: "Withdrawal to Cloud Wallet",
  101899: "Are you sure you want to withdraw all your spot commissions to your cloud wallet?",
  101900: "Ver fondos",
  101901: "Todas las monedas",
  101902: "No retirado",
  101903: "Comisión total",
  101904: "Seleccione un país o región",
  101905: "Introduce el código de verificación",
  101906: "Sistema de agentes",
  101907: "Gracias",
  101908: "Su solicitud ha sido enviada. Por lo general, revisamos su información en un plazo de 2-3 días hábiles, ¡y su comisión será efectiva después de aprobar la revisión!",
  //代理商拉新
  92000000: "Cuenta regresiva",
  92000001: "Método de participación",
  92000002: "Necesita asegurarse de que la cuenta que realiza la tarea coincida con su cuenta registrada/iniciada en la página actual para tener la oportunidad de ganar recompensas.",
  92000003: "Esperando la verificación de tarea",
  92000004: 'Regístrese en SuperEx por invitación de <span style="color:#000922;font-weight:500;">{brokerName}</span> para desbloquear el bono de bienvenida por tiempo limitado!',
  92000005: "Comienzo desde {time}",
  92000006: "Completar para {time}",
  92000007: "La verificación de la finalización de la tarea puede tardar hasta 7 días hábiles, por favor sea paciente.",
  92000008: "Unos 7 días después del evento",
  92000009: "La recompensa se distribuirá a la cuenta dentro de los 7 días hábiles posteriores a la validación del evento.",
  92000010: 'Registrarse usando el enlace de invitación de <span style="color:#000922;font-weight:400;">{brokerName}</span>',
  92000011: "Términos y condiciones",
  92000012: "Actividad en progreso",
  92000013: "No se puede participar en este evento",
  92000014: "Evento finalizado",
  92000015: "Reclamar recompensa",
  92000016: "Iniciar sesión ahora",
  92000017: "Por favor, establezca un apodo",

  92000018: "Observaciones",
  92000019: "Este artículo es obligatorio",
  92000020: "Guardar",
  92000021: 'Compartir póster',
  92000022:'Máximo ',
  92000023:'Editar canal',
  92000024:'Crear canal afiliado',
  92000025:'No hay código de invitación en este canal',
  92000026:'',
  92000027:'',
  92000028:'',
  92000029:'',
  92000030:'',
};
export default es;



// WEBPACK FOOTER //
// ./src/i18n/langs/languageJame/es.js